import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { feature } from 'topojson-client';
import { GeoJSON, withLeaflet } from 'react-leaflet';
import fetch from 'unfetch';

import { filterHHIsland } from '~/scripts/state/selectors';

class Overlay extends PureComponent {
  static propTypes = {
    fill: PropTypes.bool,
    fillColor: PropTypes.string,
    weight: PropTypes.number,
    color: PropTypes.string,
    opacity: PropTypes.number,
    data: PropTypes.object,
    smoothFactor: PropTypes.number
  };

  static defaultProps = {
    fill: false,
    fillColor: 'transparent',
    weight: 0.5,
    // weight: 2, //screenshot
    color: '#ddd',
    // color: '#ccc', //screenshot
    opacity: 1,
    data: null,
    smoothFactor: 0.5
  };

  state = {
    geojsonData: null,
    isSmallZoom: false
  };

  componentDidMount() {
    this.props.leaflet.map.on('zoom', () => this.updateStyle());
    this.getData();
  }

  async getData() {
    const response = await fetch('data/nrw_krs_plus_aachen.topo.json');
    const topojson = await response.json();
    const topoKey = Object.keys(topojson.objects)[0];
    const geojsonData = feature(topojson, topojson.objects[topoKey]);

    this.updateStyle();

    this.setState({
      geojsonData
    });
  }

  updateStyle() {
    const zoom = this.props.leaflet.map.getZoom();
    this.setState({ isSmallZoom: zoom <= 8 });
  }

  render() {
    if (!this.props.data || !this.state.geojsonData) {
      return null;
    }

    const weight = this.state.isSmallZoom ? 0.5 : 1;

    return (
      <GeoJSON
        data={this.state.geojsonData}
        fill={this.props.fill}
        fillColor={this.props.fillColor}
        weight={weight}
        color={this.props.color}
        opacity={this.props.opacity}
        smoothFactor={this.props.smoothFactor}
        className={this.props.className}
        key={`${this.props.id}_${+this.state.isSmallZoom}`}
        filter={feat => filterHHIsland(feat)}
      />
    );
  }
}

export default withLeaflet(Overlay);
